import {Button, Col, message, Row} from 'antd';
import React, {Component} from 'react';
import {connect} from "react-redux";
import {
    startScanning,
    takeSelectedPreview,
    updatePreviewStatus
} from "../../../redux_actions/preview_status.action";
import {RegionSelectionConstants} from "../../../redux_constants/region_selection.constant";
import {deviceType, objectiveType, progressStage, scanSpeed, specimenType} from '../../../utils/const';
import SlotComponentBlood from '../slot_component_blood';
import BloodSlideView from './blood_slide_view';
import LoadSlidesPrompt from './loadSlidesPrompt';
import '../../../asset/style/workflow/set-params.css';
import {getKeyByValue, isNull} from "../../../utils/utils";
import {isMonolayerDone} from "../preview_utils";
import {checkSystemState} from "../../../utils/scanner_utils";
import {get} from "../../../helper/request";
import {error_manager} from "../../../helper/error_manager";

let SPECIMEN = {
    'PAP': specimenType.PAP,
    'HE': specimenType.HNE_TISSUE,
    'IHC': specimenType.IHC,
    'BM': specimenType.BM,
    'BLOOD': specimenType.BLOOD,
}

let SCAN_SPEED = {
    'Minor': scanSpeed.FAST,
    'Few': scanSpeed.MEDIUM,
    'Major': scanSpeed.SLOW,
    'ZSTACK': scanSpeed.ZSTACK,
}

let OBJECTIVE = {
    '20x': objectiveType.TWENTY_X,
    '40x': objectiveType.FORTY_X,
    '100x': objectiveType.HUNDRED_X,
}

let ALL_SLOTS_SELECTED = [true, true, true, true, true, true]
let ALL_SLOTS_UNSELECTED = [false, false, false, false, false, false]


class SetScanParamsBloodView extends Component {
    constructor(props) {
        super(props)

        let cassetteSizeArray = [];

        for (let i = 0; i < this.props.deviceProperties.cassetteSize; i++) {
            cassetteSizeArray.push(i);
        }

        this.state = {
            specimenType: getKeyByValue(SPECIMEN, this.props.deviceProperties?.defaultConfig?.specimenType),
            scanSpeed: getKeyByValue(SCAN_SPEED, this.props.deviceProperties?.defaultConfig?.scanSpeed),
            objectiveType: getKeyByValue(OBJECTIVE, this.props.deviceProperties?.defaultConfig?.objectiveType),
            expandedSlide: false,
            selectedSlots:  ALL_SLOTS_UNSELECTED,
            isFetching: false,
            isFetchingAllPreviews: false,
            slotIndexes: this.props.deviceProperties.deviceType === deviceType.MORPHOLENS_1 || this.props.deviceProperties.deviceType === deviceType.HEMOLENS_1 ? [0] : cassetteSizeArray,
            device_id: 1,
            totalSelectedSlots: 0,
            cassetteSize: this.props.deviceProperties.cassetteSize,
            selectedSlotIndex: this.props.deviceProperties.cassetteSize === 1 ? 0 : -1,
            defaultConfig: this.props.deviceProperties.defaultConfig,
        };
        this.slideElement =  { 
            0: React.createRef(),
            1: React.createRef(),
            2: React.createRef(),
            3: React.createRef(),
            4: React.createRef(),
            5: React.createRef(),
        }
    }

    componentDidMount = () => {
    }

    componentDidUpdate = (prevProps) => {
        if ((prevProps.deviceStatus.uiBusy || {}).status === true
                && (this.props.deviceStatus.uiBusy || {}).status === false) {
            this.setState({
                isFetching: false,
            })
        }
    }

    toggleCheckbox = (index) => {
        let selectedSlots = [...this.state.selectedSlots];
        selectedSlots[index] = selectedSlots[index] ? false : true
        this.setState({
            selectedSlots: selectedSlots
        });
        if ((this.props.previews[index].status === RegionSelectionConstants.CONFIRMED || this.props.previews[index].status === RegionSelectionConstants.COARSE_DONE)) {
            // if (this.props.previews[index].response !== undefined){
            //     this.props.previews[index].status = RegionSelectionConstants.FETCHED_IMAGE
            // } else {
            //     this.props.previews[index].status = RegionSelectionConstants.NOT_STARTED
            // }
            this.props.previews[index].status = RegionSelectionConstants.NOT_STARTED;
            // this.props.dispatch(updatePreviewStatus(index, RegionSelectionConstants.NOT_STARTED));
            let url = `/server/devices/${this.props.device_id}/remove_blood_params/?slot_id=${index}`;
                get(url).then(res=>{
                console.log("slot reset done");
            })
            // this.props.dispatch(initPreviewForScan(index, this.props.defaultConfig));
        } else {
            this.props.previews[index].status = RegionSelectionConstants.CONFIRMED;
        }
        this.slideElement[index].current.toggleSelection();
    }

    expandedSlideView = (key) => {
        if (this.props.previews[key].status === RegionSelectionConstants.SELECTION_DONE || 
            this.props.previews[key].status === RegionSelectionConstants.CONFIRMED) {
			this.props.dispatch(updatePreviewStatus(key, RegionSelectionConstants.FETCHED_IMAGE));
        }
        this.setState({
            selectedSlotIndex: key,
            expandedSlide: true,
        });
    }

    closeExpadedSlideView = (slot_id) => {
        this.setState({
            expandedSlide: false,
        });
        // this.toggleCheckbox(slot_id);
    }

    ejectCassette = () => {
        const url = "/server/devices/" + this.state.device_id + "/eject/?background=false";
        get(url)
        .then(res => {
            message.success("Ejected successfully.");
            this.props.navigateToScannerDashboard();
        })
        .catch(err => {
            error_manager("Eject Failed. Contact Admin", err)
        });
    }

    beforePreview = () => {
        let goScan = false;
        for(let i=0; i < Object.keys(this.props.previews || {}).length-1; i++) {
            if ((this.props.previews[i] || {}).status === RegionSelectionConstants.CONFIRMED &&
            !((this.props.previews[i] || {}).dropDistancePoint !== undefined && (this.props.previews[i] || {}).dropDistancePoint.length > 0)) {
                goScan = true;
            }
        }

        if (goScan === true) {
            this.takeSelectedPreview();
        } else {
            message.error("Please select atleast one slot for taking preview.")
        }
    }

    takeSelectedPreview = () => {
        this.setState({
            isFetchingAllPreviews: true,
        });
        let selectedSlots = [];
        for (let i=0; i<this.state.cassetteSize; i++) {
            if(this.props.previews[i].status === RegionSelectionConstants.CONFIRMED &&
            !((this.props.previews[i] || {}).dropDistancePoint !== undefined && (this.props.previews[i] || {}).dropDistancePoint.length > 0)) {
                selectedSlots.push(i)
            }
        }
        
        this.props.dispatch(takeSelectedPreview(this.props.device_id, selectedSlots, this.fetched, true, false, false));
    }

    fetched = () => {
        this.setState({
            isFetchingAllPreviews: false,
        })
    }

    onStartScanning = () => {
        let goScan = false;
        for(let i=0; i < Object.keys(this.props.previews || {}).length-1; i++) {
            const isReadyToScan =  [RegionSelectionConstants.CONFIRMED, RegionSelectionConstants.FETCHED_IMAGE, RegionSelectionConstants.COARSE_STARTED, RegionSelectionConstants.COARSE_DONE, RegionSelectionConstants.SELECTION_DONE].includes(this.props.previews[i]?.status)
            if (isReadyToScan) {
                goScan = true;
                break;
            }
        }

        if (goScan === true) {
            this.props.dispatch(startScanning(this.state.device_id, this.props.previews, this.props.bloodConfig, true));
            this.props.handleProgressChange(progressStage.SCANNING);
        } else {
            message.error("Please select atleast one slot before starting scan.")
        }
    }

    render() {
        let isFetchingAllPreviews = false;
        let currPreviewStatus = (((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response|| {}).scanPreviewStatus;
        if (isNull(currPreviewStatus)) {
            //TODO: show a generic page
            return;
        }

        for (const [key, value] of Object.entries(currPreviewStatus)) {
            if (value.previewOngoing) {
                isFetchingAllPreviews = true;
                break;
            }
        }

        let totalScannableSlots = 0, totalSelectedSlotsApplicableForPreview = 0;
        for (let id in this.props.previews) {
	        if((this.props.previews[id] || {}).status === RegionSelectionConstants.CONFIRMED ||
		        (this.props.previews[id] || {}).status === RegionSelectionConstants.FETCHED_IMAGE ||
		        (this.props.previews[id] || {}).status === RegionSelectionConstants.COARSE_DONE) {
                // if direct scan 
                totalScannableSlots++;
            }
        }

        for (let id=0; id<this.state.cassetteSize;id++){
            if(this.state.selectedSlots[id] && !isMonolayerDone(currPreviewStatus[id])){
                totalSelectedSlotsApplicableForPreview++;
            }
        }

        let slides = this.state.slotIndexes.map((index) => {
			const checkSelected = (this.props.previews[index] || {}).status === RegionSelectionConstants.CONFIRMED || (this.props.previews[index] || {}).status === RegionSelectionConstants.FETCHED_IMAGE || (this.props.previews[index] || {}).status === RegionSelectionConstants.COARSE_DONE;
            return <Col span={this.props.deviceProperties.deviceType === deviceType.MORPHOLENS_1 || this.props.deviceProperties.deviceType === deviceType.HEMOLENS_1 ? 5 : 4 } align={'middle'} justify={'center'}
                className={this.state.selectedSlotIndex === index && this.state.expandedSlide ===  true ? "active-slot" : ""}>
                <BloodSlideView 
                    key={index}
                    ref={this.slideElement[index]}
                    expandedSlide={this.state.expandedSlide} 
                    expandedSlideView={this.expandedSlideView} 
                    slot_id={index} 
                    defaultConfig={this.state.defaultConfig}
                    device_id={this.state.device_id}/>
                <Button className="select-button" 
                    size="small" 
                    type={checkSelected ? "danger" : ""}
                    onClick={(e) => {e.stopPropagation(); this.toggleCheckbox(index)}}
                    disabled={isFetchingAllPreviews}>
                    {checkSelected ? "Remove" : "Select"}
                </Button>
            </Col>
        });

        let isSixSlideScanner = this.props.deviceProperties.deviceType === deviceType.MORPHOLENS_6 || this.props.deviceProperties.deviceType === deviceType.HEMOLENS_6;
        return (
            // <Spin spinning={this.state.isFetchingAllPreviews} tip={(this.props.deviceStatus[this.props.device_id] || {}).busyMessage}>
                <div className="relative-position">
                    <div className={this.props.currentProcessIndex !== progressStage.LOAD_SLIDES ? "" : "blur"}>
                        { !(this.state.expandedSlide) ?
                            <Row>
                                <Col offset={isSixSlideScanner ? 0 : 10} span={isSixSlideScanner ? 24 : 12}> 
                                    <Row>
                                        {slides}
                                    </Row>
                                </Col>
                            </Row>
                        : 
                            this.props.currentProcessIndex !== progressStage.LOAD_SLIDES ?
                                <div>
                                    <Row>
                                        <div className='editing-pane'>
                                            <SlotComponentBlood id={this.state.selectedSlotIndex}
                                                                device_id={this.state.device_id}
                                                                slideId = {((currPreviewStatus[this.state.selectedSlotIndex]||{}).previewResponse||{}).slideId}
                                                                defaultConfig={this.state.defaultConfig}
                                                                cassetteSize={this.state.cassetteSize}
                                                                startScanning={this.onStartScanning}
                                                                closeExpadedSlideView={() => this.closeExpadedSlideView(this.state.selectedSlotIndex)}
                                                                onPreviewFinalization={this.onPreviewFinalization}
                                                                expandedView = {this.state.expandedSlide}
                                                                slot_id = {this.state.selectedSlotIndex}
                                                                preview = {currPreviewStatus[this.state.selectedSlotIndex]}
                                            />
                                        </div>
                                    </Row>
                                </div>
                                : null
                        }

                        <Row className={(this.state.expandedSlide) ? "actionable-buttons-parent-div-set-params-index" : "actionable-buttons-parent-div-set-params"}>
                            <Col span={5} className="actionable-buttons-div-set-params">
                                <Button onClick={this.props.navigateToScannerDashboard} type="primary" className="actionable-buttons-set-params"
                                    disabled={(this.props.deviceStatus[this.props.device_id] || {}).uiBusy || isFetchingAllPreviews}>
                                    Back to Scanner Dashboard
                                </Button>
                            </Col>
                            <Col span={5} className="actionable-buttons-div-set-params">
                                <Button onClick={this.ejectCassette} type="danger" className="actionable-buttons-set-params"
                                    disabled={(this.props.deviceStatus[this.props.device_id] || {}).uiBusy || isFetchingAllPreviews}>
                                    Eject Cassette
                                </Button>
                            </Col>
                            <Col span={5} className="actionable-buttons-div-set-params">
                                <Button onClick={this.beforePreview} type="primary" className="actionable-buttons-set-params"
                                    disabled={totalSelectedSlotsApplicableForPreview === 0 || (this.props.deviceStatus[this.props.device_id] || {}).uiBusy || isFetchingAllPreviews}>
                                    Select Monolayer
                                </Button>
                            </Col>
                            <Col span={5} className="actionable-buttons-div-set-params">
                                <Button onClick={this.onStartScanning} type='primary' className="actionable-buttons-set-params"
                                    disabled={totalScannableSlots === 0 || (this.props.deviceStatus[this.props.device_id] || {}).uiBusy || isFetchingAllPreviews || checkSystemState(this.props.deviceStatus)}>
                                    Scan Now ({totalScannableSlots} Slots Selected)
                                </Button>
                            </Col>
                        </Row>
                    </div>
                    {this.props.currentProcessIndex === progressStage.LOAD_SLIDES ?
                        <LoadSlidesPrompt 
                            handleProgressChange={this.props.handleProgressChange} 
                            currentProcessIndex={this.props.currentProcessIndex} 
                            cassetteSize={this.state.cassetteSize}
                        />
                        : 
                        null
                    }
                </div>
            // </Spin>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        previews: state.previewStatusReducer,
        deviceStatus: state.deviceStatusReducer,
        bloodConfig: state.bloodConfigReducer,
        deviceProperties: state.deviceAlert.deviceProperties,
    };
};

export default connect(mapStateToProps)(SetScanParamsBloodView);
